export default __webpack_public_path__ + "static/media/impact_noises.500cc286.svg";